import React, { Component } from 'react';
import Help from '../../../helper/help';
import Balance from './balance';
import TakeOrders from './takingOrders';
import './collateral.css';

class NRG extends Component {
  render() {
    return (
      <div className='col s12' style={{}}>
        <Balance/>
      </div>
		)
  }
}

// <div classname='col s12'>
//   <TakeOrders/>
// </div>

export default NRG
